import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { searchBizestCancelResults } from './apis'
import type { BizestCancelResultRowDto, BizestCancelResultSearchReq } from './types'

export const bizestCancelResultQueryKeys = {
  all: ['BIZEST_CANCEL_RESULT'] as const,
  list: (params: BizestCancelResultSearchReq | null) => [...bizestCancelResultQueryKeys.all, 'LIST', params] as const,
}

/** 조회 — params 가 null 이면(아직 [조회] 전) 부르지 않는다. 실패 알림은 전역 처리(errorToast)가 띄운다. */
export const useGetBizestCancelResults = (params: BizestCancelResultSearchReq | null): UseQueryResult<BizestCancelResultRowDto[], Error> =>
  useQuery({
    queryKey: bizestCancelResultQueryKeys.list(params),
    queryFn: async () => (await searchBizestCancelResults(params as BizestCancelResultSearchReq)).data ?? [],
    enabled: params !== null,
    meta: { errorToast: true },
  })
